import { NavLink, Outlet } from "react-router-dom";

const Subscription = () => {
  return (
    <div>
      <nav
        style={{
          marginTop: "1rem",
          marginBottom: "1rem",
          marginLeft: "1rem",
          display: "flex",
          gap: "1rem",
        }}
      >
        {/* Use NavLink for active tab styling */}
        <NavLink
          to="/subscription"
          end
          className={({ isActive }) =>
            isActive
              ? "whitespace-nowrap font-bold text-xl border-b-4 border-[#2394f6] text-[#2394f6]"
              : "whitespace-nowrap font-bold text-xl text-gray-500 hover:text-[#2394f6]"
          }
        >
          Overview
        </NavLink>
        <NavLink
          to="/subscription/list"
          className={({ isActive }) =>
            isActive
              ? "whitespace-nowrap font-bold text-xl border-b-4 border-[#2394f6] text-[#2394f6]"
              : "whitespace-nowrap font-bold text-xl text-gray-500 hover:text-[#2394f6]"
          }
        >
         Subscription List
        </NavLink>
        <NavLink
          to="/subscription/transaction"
          className={({ isActive }) =>
            isActive
              ? "whitespace-nowrap font-bold text-xl border-b-4 border-[#2394f6] text-[#2394f6]"
              : "whitespace-nowrap font-bold text-xl text-gray-500 hover:text-[#2394f6]"
          }
        >
         Transaction List
        </NavLink>
      </nav>

      {/* Render child routes here */}
      <Outlet />
    </div>
  );
};

export default Subscription;
